/* eslint-disable import/prefer-default-export,no-undef */
export const jUploaderMixins = {
  methods: {
    startUpload() {
      this.$refs.loadingScreen.showLoadingScreen();
    },
    finallySuccess() {
      this.$refs.loadingScreen.closeLoadingScreen();
      // this.$refs.successScreen.toggleSuccessScreen();
      this.toggleSuccess('File has been successfully uploaded');
    },
    finallyFailed() {
      this.$refs.loadingScreen.closeLoadingScreen();
      // this.$refs.problemScreen.toggleProblemScreen();
      this.toggleProblem(this.error_message);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/file-uploader/jUploaderMixins.js